import get from 'lodash/get';
import {
  gettingLanguageNames,
  getItemOrDefaultToValue,
  nestedDisplay,
} from '../../details';

export const transform = ({
  data,
  languageList,
  globalDepartmentList = [],
}) => {
  // This gives the list of assigned departments for this customer
  const selectedDepartments = globalDepartmentList.filter(f =>
    getItemOrDefaultToValue(data.general, 'departmentIds', []).includes(f.id),
  );

  // This will give the assigned departments for the linked businessClient in customers object
  const assignedDepartmentsForBusinessClient = getItemOrDefaultToValue(
    data.general,
    'businessClientDepartmentIds',
    [],
  );
  return {
    generalInfo: {
      customerId: {
        type: 'text',
        field: 'employeeId',
        label: 'Customer ID',
        value: getItemOrDefaultToValue(data.general, 'employeeId', '-'),
      },
      firstName: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'firstName', '-'),
      },
      lastName: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'lastName', '-'),
      },
      phone: {
        type: 'text',
        value:
          data.general.phoneNumber !== null
            ? `${getItemOrDefaultToValue(
                data.general.phoneNumber,
                'prefix',
              )} ${getItemOrDefaultToValue(
                data.general.phoneNumber,
                'number',
                '-',
              )}`
            : '-',
      },
      email: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'email', '-'),
      },
      departments: {
        type: 'array',
        label: 'Departments',
        value: nestedDisplay(selectedDepartments),
      },
    },
    detailedInfo: {
      businessClient: {
        type: 'text',
        value: getItemOrDefaultToValue(data.general, 'businessClientName', '-'),
      },
      emailVerified: {
        type: 'boolean',
        value: getItemOrDefaultToValue(
          data.details.verifications,
          'emailVerified',
          false,
        ),
      },
      phoneVerified: {
        type: 'boolean',
        value: getItemOrDefaultToValue(
          data.details.verifications,
          'phoneVerified',
          false,
        ),
      },
      languages: {
        type: 'text',
        value:
          data.details != null
            ? gettingLanguageNames(
                get(data.details, 'languages', []),
                languageList,
              )
            : '-',
      },
      notes: {
        type: 'text',
        value: getItemOrDefaultToValue(data.details, 'notes', '-'),
      },
    },
    others: {
      id: { value: data.general.id },
      phone: {
        value:
          data.general.phoneNumber !== null
            ? getItemOrDefaultToValue(data.general.phoneNumber, 'number', '-')
            : '-',
      },
      businessClient: {
        value: {
          id: getItemOrDefaultToValue(data.general, 'businessClientId', '-'),
          name: getItemOrDefaultToValue(
            data.general,
            'businessClientName',
            '-',
          ),
          assignedDepartmentList: data.general?.businessClientId
            ? assignedDepartmentsForBusinessClient
            : [],
        },
      },
      image: {
        value: getItemOrDefaultToValue(data.general, 'photoUrl'),
      },
      archived: {
        value: getItemOrDefaultToValue(data.details, 'archived', false),
      },
      languages: {
        value: getItemOrDefaultToValue(data.details, 'languages', []),
      },
      country: {
        value:
          data.general.phoneNumber !== null
            ? getItemOrDefaultToValue(data.general.phoneNumber, 'country', '-')
            : '-',
      },
      status: {
        value: getItemOrDefaultToValue(data.operational, 'status', 'INACTIVE'),
      },
    },
  };
};
